<div class="container">

  <app-header-dialog [iconName]="'filter_tilt_shift'">
    Atividade
    <!--
    <span *ngIf="data.activity"> - {{data.activity.id}}</span>
       -->
  </app-header-dialog>


  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !_activityService.spinner}" color='warn' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <div class='bread-crumb' flex>
    <mat-icon color="accent">arrow_right</mat-icon>
    {{ _activityService.breadCrumb(_activityService.currentEvent.name) }}
    <mat-icon color="accent">arrow_right</mat-icon>
    {{ _activityService.breadCrumb(_activityService.currentDay.name) }}
    <mat-icon color="accent">arrow_right</mat-icon>
    {{ _activityService.breadCrumb(_activityService.localTitle) }}
  </div>

  <form class="form" name="activityForm" [formGroup]='activityForm' autocomplete="off">

    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>filter_tilt_shift</mat-icon>
          <div>Atividade</div>
        </ng-template>

        <div class='tab-content'>

          <div>

            <mat-form-field class="date-width" appearance="outline">
              <mat-label>Data</mat-label>
              <input readonly matInput [matDatepicker]="picker" [errorStateMatcher]="matcher"
                [formControl]="activityForm.controls.date">
              <mat-datepicker-toggle disabled matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="startTime-width" appearance="outline">
              <mat-label>Início</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="activityForm.controls.startTime"
                autocomplete="off">
              <mat-error *ngIf="activityForm.controls.startTime.hasError('required')">
                Horário é obrigatório
              </mat-error>
            </mat-form-field>

            <mat-form-field class="local-width" appearance="outline">
              <mat-label>Sala</mat-label>
              <mat-select [errorStateMatcher]="matcher" (ngModelChange)='selecteRoom($event)'
                [formControl]="activityForm.controls.location_id">
                <mat-option *ngFor="let room of _conventionCenterService.conventionCenterCurrent.rooms"
                  [value]="room.id">
                  <span>{{room.name}}</span>
                </mat-option>
              </mat-select>
              <mat-error *ngIf="activityForm.controls.location_id.hasError('required')">
                A Sala é obrigatória
              </mat-error>
            </mat-form-field>

          </div>

          <div>

            <mat-form-field class="depto-width" appearance="outline">
              <mat-label>Nome Departamento</mat-label>
              <mat-select [errorStateMatcher]="matcher" (ngModelChange)='selecteDepartent($event)'
                [formControl]="activityForm.controls.depto_id">
                <mat-option *ngFor="let depto of _departmentService.departments" [value]="depto.id">
                  <span>{{depto.short}}</span>
                </mat-option>
              </mat-select>
              <mat-error *ngIf="activityForm.controls.depto_id.hasError('required')">
                O Departamento é obrigatório
              </mat-error>
            </mat-form-field>


            <mat-form-field class="name-width" appearance="outline">
              <mat-label>Nome Atividade</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="activityForm.controls.name"
                autocomplete="off">
              <mat-error *ngIf="activityForm.controls.name.hasError('required')">
                O Nome é obrigatório
              </mat-error>
            </mat-form-field>

          </div>

          <div style="width: 860px;">
            <ckeditor [config]="{ 
                        toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
              [formControl]="activityForm.controls.text" [editor]="Editor"></ckeditor>
            <mat-error *ngIf="activityForm.controls.text.hasError('required')">
              O Texto é obrigatório
            </mat-error>
          </div>

        </div>
        <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
          <button mat-raised-button (click)='insert()' [disabled]="activityForm.invalid"
            *ngIf="!_activityService.isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
          </button>
          <button mat-raised-button (click)='update()' [disabled]="activityForm.invalid"
            *ngIf="_activityService.isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
          </button>
        </div>

      </mat-tab>

      <mat-tab *ngIf='_activityService.isEdit'>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>people</mat-icon>
          <div>Equipe</div>
        </ng-template>

        <div class='tab-content-table'>

          <!-- TABLE -->
          <mat-table [dataSource]="agendaActivityDataSource" matSort matSortActive="role_name"
            style='height: calc(100vh - 250px); overflow:auto;'>

            <!-- Name Column -->
            <ng-container matColumnDef="member_name">
              <mat-header-cell *matHeaderCellDef> Colaborador </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div style='padding:5px;' flex fxLayout="column" fxLayoutAlign="start start">

                  <div class='item-agenda-role'>
                    {{ element.member_name }} - {{ element.member_state }}, {{ element.member_country }}
                  </div>

                  <div class='item-agenda' *ngIf='!element.dateConfirmed'>
                    <div class='item-agenda-label'>Confirmar:</div>
                    <div class='item-agenda-data'>
                      <span *ngIf='element.requireConfirm'>Sim</span>
                      <span *ngIf='!element.requireConfirm'>Não</span>
                    </div>
                  </div>

                  <div class='item-agenda' *ngIf='element.dateConfirmed'>
                    <div class='item-agenda-label'>Confirmado:</div>
                    <div class='item-agenda-data'>
                      {{ element.confirmed.seconds*1000 | date:'dd/MM/yyyy'}}
                    </div>
                  </div>
                </div>

              </mat-cell>
            </ng-container>

            <!-- Agenda Column -->
            <ng-container matColumnDef="role_name">
              <mat-header-cell *matHeaderCellDef> Agenda </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div style='padding:5px;' flex fxLayout="column" fxLayoutAlign="start start">

                  <div class='item-agenda-role'>
                    {{ element.role_name }}
                  </div>

                  <div class='item-agenda'>
                    <div class='item-agenda-label'>{{ element.day_date.seconds*1000 | date:
                      'dd/MM/yyyy'}}: </div>
                    <div class='item-agenda-data'>{{ element.day_name }}</div>
                  </div>

                  <div class='item-agenda'>
                    <div class='item-agenda-label'>Depto:</div>
                    <div class='item-agenda-data'>{{ element.depto_name }}</div>
                  </div>

                  <div class='item-agenda'>
                    <div class='item-agenda-label'>Atividade:</div>
                    <div class='item-agenda-data'>{{ element.activity_startTime }} - {{
                      element.activity_name }}</div>
                  </div>


                </div>
              </mat-cell>
            </ng-container>

            <!-- edit Column -->
            <ng-container matColumnDef="button_edit">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a (click)='openStaffDialog(element)' style='cursor:pointer;'>
                  <mat-icon class="icon-info">
                    info_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <!-- delete Column -->
            <ng-container matColumnDef="button_delete">
              <mat-header-cell *matHeaderCellDef>
                <a mat-button (click)="openStaffDialog(null)">
                  <mat-icon color='primary'>add_circle_outline</mat-icon>
                </a>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a (click)='_agendaService.removeAgenda(element)' style='cursor:pointer;'>
                  <mat-icon class='icon-delete'>
                    delete_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <!-- Header -->
            <mat-header-row *matHeaderRowDef="displayedAgendaColumns; sticky: true"></mat-header-row>

            <!-- Row -->
            <mat-row *matRowDef="let row; columns: displayedAgendaColumns;">
            </mat-row>

          </mat-table>
          <!-- END TABLE -->

        </div>

      </mat-tab>

      <mat-tab *ngIf='_activityService.isEdit'>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>flare</mat-icon>
          <div>Tópicos</div>
        </ng-template>

        <div class='tab-content-table'>

          <!-- TABLE -->
          <mat-table [dataSource]="_topicService.topicDataSource" matSort matSortActive="startTime"
            style='height: calc(100vh - 250px); overflow:auto;'> *ngIf='_activityService.isEdit'>

            <!-- icon Column -->
            <ng-container matColumnDef="icon">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <mat-icon>flare</mat-icon>
              </mat-cell>
            </ng-container>

            <!-- StartTime Column -->
            <ng-container matColumnDef="date">
              <mat-header-cell *matHeaderCellDef> Horário </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.startTime }} </mat-cell>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef mat-sort-header><span class='head-color'> Tópicos </span>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.name }} </mat-cell>
            </ng-container>


            <!-- edit Column -->
            <ng-container matColumnDef="edit">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='openTopicDialog(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-info'>
                    info_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <!-- delete Column -->
            <ng-container matColumnDef="delete">
              <mat-header-cell *matHeaderCellDef>
                <a mat-button (click)="openTopicDialog(null)">
                  <mat-icon color='primary'>add_circle_outline</mat-icon>
                </a>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='deleteTopic(element)' style='background-color: whitesmoke;'>
                  <mat-icon class="icon-delete">delete_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <!-- Header -->
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

            <!-- Row -->
            <mat-row *matRowDef="let row; columns: displayedColumns;">
            </mat-row>

          </mat-table>
          <!-- END TABLE -->

        </div>

      </mat-tab>

      <mat-tab *ngIf='_activityService.isEdit'>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>people</mat-icon>
          <div>Apoio</div>
        </ng-template>

        <div class='tab-content-table'>

          <!-- TABLE -->
          <mat-table [dataSource]="sponsorsDataSource" style='height: calc(100vh - 250px); overflow:auto;'>

            <!-- image -->
            <ng-container matColumnDef="image">
              <mat-header-cell *matHeaderCellDef>Imagem</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <ng-container>
                  <img class='banner_image' [src]='element.image'>
                </ng-container>
              </mat-cell>
            </ng-container>

            <!-- Link Column -->
            <ng-container matColumnDef="link">
              <mat-header-cell *matHeaderCellDef> Link </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.link }}
              </mat-cell>
            </ng-container>

            <!-- delete Column -->
            <ng-container matColumnDef="delete">
              <mat-header-cell *matHeaderCellDef>
                <a mat-button (click)="openBannerDialog(null)">
                  <mat-icon color='primary'>add_circle_outline</mat-icon>
                </a>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='removeBannerSponsor(element)' style='background-color: whitesmoke;'>
                  <mat-icon style='font-size:1.5em; color:rgba(247, 10, 10, 0.7)'>delete_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <!-- Header -->
            <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedSponsorColumns">
            </mat-header-row>

            <!-- Row -->
            <mat-row *matRowDef="let row; columns: displayedSponsorColumns;">
            </mat-row>

          </mat-table>
          <!-- END TABLE -->
        </div>


      </mat-tab>

      <mat-tab *ngIf='_activityService.isEdit'>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>preview</mat-icon>
          <div>Prévia</div>
        </ng-template>


        <div class='tab-content-table'>

          <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end' *ngIf='_activityService.isEdit'>
            <button mat-raised-button (click)='refreshPreview()'>
              <mat-icon class='icon-add'>preview</mat-icon>
            </button>
          </div>

          <div *ngIf="htmlPreview" style="padding: 10px 0 10px 0; font-size: 1.1em;">
            {{_activityService.currentActivity.location}}
          </div>

          <hr>

          <div [innerHTML]="htmlPreview" style="height: calc(100vh - 350px); overflow:auto;">
          </div>

        </div>


      </mat-tab>

    </mat-tab-group>

  </form>

</div>